
import { isZilrettaUser } from "src/helpers";
import { HeaderElementType } from "src/types";
import { UserType } from "src/types/users";
 // adjust import path

//:- Validation based constants
export const EMAIL_REGEX =/^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,70}$/;

export const MAX_FILE_SIZE = 25 * 1024 * 1024;

export const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DC", label: "District of Colombia" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "FM", label: "Federated States of Micronesia" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota"},
  { value: "MS", label: "Mississippi"},
  { value: "MO", label: "Missouri"},
  { value: "MP", label: "Northern Mariana Islands"},
  { value: "MT", label: "Montana"},
  { value: "NE", label: "Nebraska"},
  { value: "NV", label: "Nevada"},
  { value: "NH", label: "New Hampshire"},
  { value: "NJ", label: "New Jersey"},
  { value: "NM", label: "New Mexico"},
  { value: "NY", label: "New York"},
  { value: "NC", label: "North Carolina"},
  { value: "ND", label: "North Dakota"},
  { value: "OH", label: "Ohio"},
  { value: "OK", label: "Oklahoma"},
  { value: "OR", label: "Oregon"},
  { value: "PA", label: "Pennsylvania"},
  { value: "PW", label: "Palau"},
  { value: "PR", label: "Puerto Rico"},
  { value: "RI", label: "Rhode Island"},
  { value: "SC", label: "South Carolina"},
  { value: "SD", label: "South Dakota"},
  { value: "TN", label: "Tennessee"},
  { value: "TX", label: "Texas"},
  { value: "UT", label: "Utah"},
  { value: "VT", label: "Vermont"},
  { value: "VI", label: "Virgin Islands"},
  { value: "VA", label: "Virginia"},
  { value: "WA", label: "Washington"},
  { value: "WV", label: "West Virginia"},
  { value: "WI", label: "Wisconsin"},
  { value: "WY", label: "Wyoming"},
];

export const ACCEPTED_FILE_EXTENSIONS: { [key: string]: string; } = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.tiff': 'image/tiff',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.ccd': 'application/x-ccd',
  '.cda': 'application/x-cdf',
  '.ccr': 'application/x-ccr',
  '.ccda': 'application/x-ccda',
};

export const ACCEPTED_FILE_EXTENSIONS_CASE: { [key: string]: string; } = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.tiff': 'image/tiff',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.ccd': 'application/x-ccd',
  '.cda': 'application/x-cdf',
  '.ccr': 'application/x-ccr',
  '.ccda': 'application/x-ccda',
};

export const ACCEPTED_PRECERT_FILE_EXTENSIONS: { [key: string]: string; } = {
  ...ACCEPTED_FILE_EXTENSIONS,
  '.txt': 'text/plain',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png'
};


export const USER_TYPES = {
  HCP: ['GlobalDoctor', 'Practice', 'Contact', 'Organization', 'CentralManagerUsers'],
  MANUFACTURER: ['Manufacturer', 'regional_manager', 'district_manager', 'rep', 'area_manager','fam_am','fam_rm','asc'],
  PHARMACY: ['Pharmacy', 'PharmacyOrg']
};


// export const ACCESS_TO_LOCAL_COVERAGE_REPORT = [
//   "Todd.Killian@pacira.com", "Bryan.Knapp@pacira.com", "Eric.Blair@pacira.com",
//   "Matt.Schambers@pacira.com", "trarick@AccessSync.com", "kschaffer@AccessSync.com",
//   "hoyewole@AccessSync.com", "avanvulpen@accesssync.com", "devh@cmcopilot.com",
//   "roberta.baptista@pacira.com", "timothy.mcsweeney@pacira.com", "darcy.duckenfield@pacira.com",
//   "copilotreport@cmcopilot.com", "demoreport@pacira.com"
// ]
export const ACCESS_TO_LOCAL_COVERAGE_REPORT = [
  "devh@cmcopilot.com", "roberta.baptista@pacira.com", "darcy.duckenfield@pacira.com",
  "copilotreport@cmcopilot.com", "demoreport@pacira.com", "timothy.mcsweeney@pacira.com"
]

export const MANUFACTURER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Calls',
    reportName:'call_report'
  },
  {
    reportTitle:'Texts',
    reportName:'text_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Xfer',
    reportName:'transfer_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Resource Summary',
    reportName:'resource_summary_report'
  },
  {
    reportTitle:'Co-Pay Claims Report',
    reportName:'copay_claims'
  },
  {
    reportTitle:'Local Coverage Analytics',
    reportName:'local_coverage_analytics_report'
  },
]
export const REGIONAL_MANAGER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const DISTRICT_MANAGER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const REP = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const AREA_MANAGER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Calls',
    reportName:'call_report'
  },
  {
    reportTitle:'Texts',
    reportName:'text_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Xfer',
    reportName:'transfer_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Co-Pay Claims Report',
    reportName:'co-pay_claims'
  }
]
export const FAM_AM = [
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const FAM_RM = [
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Co-Pay Claims Report',
    reportName:'copay_claims'
  },
]
export const ZILRETTA_REPORT = [
   {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
// utils/getReportsByRole.ts
//import { MANUFACTURER, REGIONAL_MANAGER, DISTRICT_MANAGER, REP, AREA_MANAGER, FAM_AM, FAM_RM } from "./reportsData"; 

// export const  getReportsByRole = (userType: UserType)=>{
  
//   let reports:any = [];
//   switch (userType.ref_type) {
//     case "Manufacturer":
//       reports = MANUFACTURER;
//       break;
//     case "regional_manager":
//       reports = REGIONAL_MANAGER;
//       break;
//     case "district_manager":
//       reports = DISTRICT_MANAGER;
//       break;
//     case "rep":
//       reports = REP;
//       break;
//     case "area_manager":
//       reports = AREA_MANAGER;
//       break;
//     case "fam_am":
//       reports = FAM_AM;
//       break;
//     case "fam_rm":
//       reports = FAM_RM;
//       break;
//     default:
//       reports = [];
//   }

//   // Convert role-specific reports → dropdown objects
//   return reports.map((r:any) => ({
//     title: r.reportTitle,
//     redirectLink: `/reports/${r.reportName.replace("_report", "")}`, // map to your route style
//     actionType: HeaderElementType.LINK,
//   }));
// }
export const getReportsByRole = (userType: UserType) => {
  let reports: any = [];

  // 🟢 1. Check Zilretta Access First
  if (userType.is_jnj) {
    reports = ZILRETTA_REPORT;
  } 
  // 🟡 2. Normal Role-Based Access
  else if (userType.ref_type === "Manufacturer") {
    reports = MANUFACTURER;
  } else if (userType.ref_type === "regional_manager") {
    reports = REGIONAL_MANAGER;
  } else if (userType.ref_type === "district_manager") {
    reports = DISTRICT_MANAGER;
  } else if (userType.ref_type === "rep") {
    reports = REP;
  } else if (userType.ref_type === "area_manager") {
    reports = AREA_MANAGER;
  } else if (userType.ref_type === "fam_am") {
    reports = FAM_AM;
  } else if (userType.ref_type === "fam_rm") {
    reports = FAM_RM;
  } else {
    reports = [];
  }

  // 🟣 3. Convert to dropdown object
  return reports.map((r: any) => ({
    title: r.reportTitle,
    redirectLink: `/reports/${r.reportName.replace("_report", "")}`,
    actionType: HeaderElementType.LINK,
  }));
};

export const redirectPath = (userData: UserType) => {
  if (userData.ref_type === 'Manufacturer' || userData.ref_type === "fam_rm" || userData.ref_type === 'fam_am') {
    return "/statistics"
  } else if (userData.ref_type === 'regional_manager') {
    return "/regions"
  } else if (userData.ref_type === 'district_manager') {
    return"/districts"
  } 
  // else if (userData.ref_type === 'fam_am') {
  //   return "/fam_regions"
  // }
  // else if (userData.ref_type === 'fam_rm') {
  //   return "/famrm_statistics"
  // }
  else if (userData.ref_type === 'rep' || userData.ref_type === 'asc') {
    return "/territories"
  } else {
    return ""
  }
}

export const MANUFACTURER_ROUTES_BY_REF_TYPE = {
  REP: ["/territories", "/users/updateuser", "/formularies", "/todos_statistics", "/cases/detail/:caseId", "/pages/signup-video", "/global_patients/:patientId", "/pages/benefits-verification-video","/doc_stats","/reports/:reportType"],
  REGIONAL_MANAGER: ["/regions", "/districts", "/territories", "/users/updateuser", "/todos_statistics", "/cases/detail/:caseId", "/global_patients/:patientId", "/formularies","/pages/signup-video","/pages/benefits-verification-video","/doc_stats","/reports/:reportType"],
  DISTRICT_MANAGER: ["/districts", "/territories", "/users/updateuser", "/todos_statistics", "/cases/detail/:caseId", "/global_patients/:patientId", "/formularies","/pages/signup-video","/pages/benefits-verification-video","/doc_stats","/reports/:reportType"]
}


export const STATIC_CPT_CODES = [
  {
    value: '15271',
    label: '15271',
  },
  {
    value: '15273',
    label: '15273',
  },
  {
    value: '15275',
    label: '15275',
  },
  {
    value: '15277',
    label: '15277',
  },
];

export const ENROLLMENT_TIMEZONE = [
  {
    value: "Eastern Time (US & Canada)",
    label: "Eastern Time (US & Canada)",
  },
  {
    value: "Central Time (US & Canada)",
    label: "Central Time (US & Canada)",
  },
  {
    value: "Mountain Time (US & Canada)",
    label: "Mountain Time (US & Canada)",
  },
  {
    value: "Pacific Time (US & Canada)",
    label: "Pacific Time (US & Canada)",
  },
];
export const GLOBAL_PATIENT_DETAIL_CASE = [
  {
    value: '',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Created',
  },
  {
    value: '',
    label: 'Treated',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Not Treated Reason',
  },
  {
    value: '',
    label: 'Indication',
  },
];

export const ACCESS_TO_ZILRETTA_DRUG = [
  'LAbbott@its.jnj.com','JBezold@its.jnj.com','LCamara@its.jnj.com',
  'FCistaro@its.jnj.com','WCook@ITS.JNJ.com','AGladfel@its.jnj.com',
  'JLiving4@its.jnj.com','LLutz@its.jnj.com','jLynch50@its.jnj.com',
  'JMcGlinc@its.jnj.com','TMeehan3@ITS.JNJ.com','JMontice@its.jnj.com',
  'bpember@its.jnj.com','RRamire5@its.jnj.com','JRANDOL2@its.jnj.com',
  'PStead2@ITS.JNJ.com','JUnderw1@ITS.JNJ.com','uwyman@its.jnj.com',
  'GYoung20@its.jnj.com','staging_jbezold@its.jnj.com','staging_fcistaro@its.jnj.com'
]